import { render, staticRenderFns } from "./Solicitudes.vue?vue&type=template&id=1993e051&scoped=true&"
import script from "./Solicitudes.vue?vue&type=script&lang=js&"
export * from "./Solicitudes.vue?vue&type=script&lang=js&"
import style0 from "./Solicitudes.vue?vue&type=style&index=0&id=1993e051&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1993e051",
  null
  
)

export default component.exports